import { Suspense } from 'react'
import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'

import NoTransactions from '../empty/no-transactions'
import SectionTitle from '../ui/section-title'
import ViewAllButton from '../ui/view-all-button'

import Listing from './listing-card'
import ListingListSkeleton from './listing-list-skeleton'

type ListingListProps = {
  firstName: string
  username: string
  showAll?: boolean
  onGoBack?: () => void
}

const LISTINGS = [
  {
    price: 1499000,
    beds: 3,
    baths: 3.5,
    sqft: 2380,
    address: '1 Wickham Rd, Garden City, NY',
    listedDate: '4 days ago',
    listingNumber: 1,
  },
  {
    price: 1895000,
    beds: 4,
    baths: 2.5,
    sqft: 2850,
    address: '15 Oak Ave, Garden City, NY',
    listedDate: '2 days ago',
    listingNumber: 2,
  },
  {
    price: 1250000,
    beds: 2,
    baths: 2,
    sqft: 1850,
    address: '8 Maple St, Garden City, NY',
    listedDate: '1 week ago',
    listingNumber: 3,
  },
  {
    price: 2200000,
    beds: 5,
    baths: 4,
    sqft: 3200,
    address: '22 Pine Rd, Garden City, NY',
    listedDate: '3 days ago',
    listingNumber: 4,
  },
  {
    price: 950000,
    beds: 2,
    baths: 1.5,
    sqft: 1450,
    address: '5 Elm Dr, Garden City, NY',
    listedDate: '5 days ago',
    listingNumber: 5,
  },
  {
    price: 1750000,
    beds: 3,
    baths: 3,
    sqft: 2600,
    address: '12 Cedar Ln, Garden City, NY',
    listedDate: '1 day ago',
    listingNumber: 6,
  },
]

const ListingListContent = ({ firstName, username, showAll = false, onGoBack }: ListingListProps) => {
  const navigate = useNavigate()
  return (
    <section className="mb-6 flex flex-col gap-3">
      <SectionTitle
        onGoBack={onGoBack}
        title={
          <>
            Listings in {firstName}&apos;s area{' '}
            <span className="text-sm font-medium text-muted lg:text-[18px]"> (465 listings)</span>
          </>
        }
      />
      <div className="mt-4 grid grid-cols-[repeat(auto-fill,minmax(236px,1fr))] gap-4">
        {LISTINGS.map((listing) => (
          <Listing
            key={listing.listingNumber}
            username={username}
            price={listing.price}
            beds={listing.beds}
            baths={listing.baths}
            sqft={listing.sqft}
            address={listing.address}
            listedDate={listing.listedDate}
            listingNumber={listing.listingNumber}
          />
        ))}
        {LISTINGS.length === 0 && <NoTransactions />}
      </div>
      {!showAll && LISTINGS.length > 0 && (
        <ViewAllButton
          text="Show all listings"
          onClick={() => navigate(paths.users.publicProfile.listings.getHref(username))}
        />
      )}
    </section>
  )
}

const ListingList = ({ firstName, username, showAll = false, onGoBack }: ListingListProps) => {
  return (
    <Suspense fallback={<ListingListSkeleton />}>
      <ListingListContent firstName={firstName} username={username} showAll={showAll} onGoBack={onGoBack} />
    </Suspense>
  )
}

export default ListingList
